export const prefixList = [
  { name: "Afghanistan", dial_code: "+93", code: "AF" },
  { name: "Albania", dial_code: "+355", code: "AL" },
  { name: "Algeria", dial_code: "+213", code: "DZ" },
  { name: "Andorra", dial_code: "+376", code: "AD" },
  { name: "Angola", dial_code: "+244", code: "AO" },
  { name: "Antigua and Barbuda", dial_code: "+1268", code: "AG" },
  { name: "Argentina", dial_code: "+54", code: "AR" },
  { name: "Armenia", dial_code: "+374", code: "AM" },
  { name: "Aruba", dial_code: "+297", code: "AW" },
  { name: "Australia", dial_code: "+61", code: "AU" },
  { name: "Austria", dial_code: "+43", code: "AT" },
  { name: "Azerbaijan", dial_code: "+994", code: "AZ" },
  { name: "Bahamas", dial_code: "+1242", code: "BS" },
  { name: "Bahrain", dial_code: "+973", code: "BH" },
  { name: "Bangladesh", dial_code: "+880", code: "BD" },
  { name: "Barbados", dial_code: "+1246", code: "BB" },
  { name: "Belarus", dial_code: "+375", code: "BY" },
  { name: "Belgium", dial_code: "+32", code: "BE" },
  { name: "Belize", dial_code: "+501", code: "BZ" },
  { name: "Benin", dial_code: "+229", code: "BJ" },
  { name: "Bhutan", dial_code: "+975", code: "BT" },
  { name: "Bolivia", dial_code: "+591", code: "BO" },
  { name: "Bosnia and Herzegovina", dial_code: "+387", code: "BA" },
  { name: "Botswana", dial_code: "+267", code: "BW" },
  { name: "Brazil", dial_code: "+55", code: "BR" },
  { name: "British Indian Ocean Territory", dial_code: "+246", code: "IO" },
  { name: "Brunei", dial_code: "+673", code: "BN" },
  { name: "Bulgaria", dial_code: "+359", code: "BG" },
  { name: "Burkina Faso", dial_code: "+226", code: "BF" },
  { name: "Burundi", dial_code: "+257", code: "BI" },
  { name: "Cambodia", dial_code: "+855", code: "KH" },
  { name: "Cameroon", dial_code: "+237", code: "CM" },
  { name: "Canada", dial_code: "+1", code: "CA" },
  { name: "Cape Verde", dial_code: "+238", code: "CV" },
  { name: "Caribbean Netherlands", dial_code: "+599", code: "BQ" },
  { name: "Central African Republic", dial_code: "+236", code: "CF" },
  { name: "Chad", dial_code: "+235", code: "TD" },
  { name: "Chile", dial_code: "+56", code: "CL" },
  { name: "China", dial_code: "+86", code: "CN" },
  { name: "Colombia", dial_code: "+57", code: "CO" },
  { name: "Comoros", dial_code: "+269", code: "KM" },
  { name: "Congo", dial_code: "+243", code: "CD" },
  { name: "Congo", dial_code: "+242", code: "CG" },
  { name: "Costa Rica", dial_code: "+506", code: "CR" },
  { name: "Croatia", dial_code: "+385", code: "HR" },
  { name: "Cuba", dial_code: "+53", code: "CU" },
  { name: "Curaçao", dial_code: "+599", code: "CW" },
  { name: "Cyprus", dial_code: "+357", code: "CY" },
  { name: "Czech Republic", dial_code: "+420", code: "CZ" },
  { name: "Côte d’Ivoire", dial_code: "+225", code: "CI" },
  { name: "Denmark", dial_code: "+45", code: "DK" },
  { name: "Djibouti", dial_code: "+253", code: "DJ" },
  { name: "Dominica", dial_code: "+1767", code: "DM" },
  { name: "Dominican Republic", dial_code: "+1", code: "DO" },
  { name: "Ecuador", dial_code: "+593", code: "EC" },
  { name: "Egypt", dial_code: "+20", code: "EG" },
  { name: "El Salvador", dial_code: "+503", code: "SV" },
  { name: "Equatorial Guinea", dial_code: "+240", code: "GQ" },
  { name: "Eritrea", dial_code: "+291", code: "ER" },
  { name: "Estonia", dial_code: "+372", code: "EE" },
  { name: "Ethiopia", dial_code: "+251", code: "ET" },
  { name: "Fiji", dial_code: "+679", code: "FJ" },
  { name: "Finland", dial_code: "+358", code: "FI" },
  { name: "France", dial_code: "+33", code: "FR" },
  { name: "French Guiana", dial_code: "+594", code: "GF" },
  { name: "French Polynesia", dial_code: "+689", code: "PF" },
  { name: "Gabon", dial_code: "+241", code: "GA" },
  { name: "Gambia", dial_code: "+220", code: "GM" },
  { name: "Georgia", dial_code: "+995", code: "GE" },
  { name: "Germany", dial_code: "+49", code: "DE" },
  { name: "Ghana", dial_code: "+233", code: "GH" },
  { name: "Greece", dial_code: "+30", code: "GR" },
  { name: "Grenada", dial_code: "+1473", code: "GD" },
  { name: "Guadeloupe", dial_code: "+590", code: "GP" },
  { name: "Guam", dial_code: "+1671", code: "GU" },
  { name: "Guatemala", dial_code: "+502", code: "GT" },
  { name: "Guinea", dial_code: "+224", code: "GN" },
  { name: "Guinea-Bissau", dial_code: "+245", code: "GW" },
  { name: "Guyana", dial_code: "+592", code: "GY" },
  { name: "Haiti", dial_code: "+509", code: "HT" },
  { name: "Honduras", dial_code: "+504", code: "HN" },
  { name: "Hong Kong", dial_code: "+852", code: "HK" },
  { name: "Hungary", dial_code: "+36", code: "HU" },
  { name: "Iceland", dial_code: "+354", code: "IS" },
  { name: "India", dial_code: "+91", code: "IN" },
  { name: "Indonesia", dial_code: "+62", code: "ID" },
  { name: "Iran", dial_code: "+98", code: "IR" },
  { name: "Iraq", dial_code: "+964", code: "IQ" },
  { name: "Ireland", dial_code: "+353", code: "IE" },
  { name: "Israel", dial_code: "+972", code: "IL" },
  { name: "Italy", dial_code: "+39", code: "IT" },
  { name: "Jamaica", dial_code: "+1876", code: "JM" },
  { name: "Japan", dial_code: "+81", code: "JP" },
  { name: "Jordan", dial_code: "+962", code: "JO" },
  { name: "Kazakhstan", dial_code: "+7", code: "KZ" },
  { name: "Kenya", dial_code: "+254", code: "KE" },
  { name: "Kiribati", dial_code: "+686", code: "KI" },
  { name: "Kosovo", dial_code: "+383", code: "XK" },
  { name: "Kuwait", dial_code: "+965", code: "KW" },
  { name: "Kyrgyzstan", dial_code: "+996", code: "KG" },
  { name: "Laos", dial_code: "+856", code: "LA" },
  { name: "Latvia", dial_code: "+371", code: "LV" },
  { name: "Lebanon", dial_code: "+961", code: "LB" },
  { name: "Lesotho", dial_code: "+266", code: "LS" },
  { name: "Liberia", dial_code: "+231", code: "LR" },
  { name: "Libya", dial_code: "+218", code: "LY" },
  { name: "Liechtenstein", dial_code: "+423", code: "LI" },
  { name: "Lithuania", dial_code: "+370", code: "LT" },
  { name: "Luxembourg", dial_code: "+352", code: "LU" },
  { name: "Macau", dial_code: "+853", code: "MO" },
  { name: "Macedonia", dial_code: "+389", code: "MK" },
  { name: "Madagascar", dial_code: "+261", code: "MG" },
  { name: "Malawi", dial_code: "+265", code: "MW" },
  { name: "Malaysia", dial_code: "+60", code: "MY" },
  { name: "Maldives", dial_code: "+960", code: "MV" },
  { name: "Mali", dial_code: "+223", code: "ML" },
  { name: "Malta", dial_code: "+356", code: "MT" },
  { name: "Marshall Islands", dial_code: "+692", code: "MH" },
  { name: "Martinique", dial_code: "+596", code: "MQ" },
  { name: "Mauritania", dial_code: "+222", code: "MR" },
  { name: "Mauritius", dial_code: "+230", code: "MU" },
  { name: "Mexico", dial_code: "+52", code: "MX" },
  { name: "Micronesia", dial_code: "+691", code: "FM" },
  { name: "Moldova", dial_code: "+373", code: "MD" },
  { name: "Monaco", dial_code: "+377", code: "MC" },
  { name: "Mongolia", dial_code: "+976", code: "MN" },
  { name: "Montenegro", dial_code: "+382", code: "ME" },
  { name: "Morocco", dial_code: "+212", code: "MA" },
  { name: "Mozambique", dial_code: "+258", code: "MZ" },
  { name: "Myanmar", dial_code: "+95", code: "MM" },
  { name: "Namibia", dial_code: "+264", code: "NA" },
  { name: "Nauru", dial_code: "+674", code: "NR" },
  { name: "Nepal", dial_code: "+977", code: "NP" },
  { name: "Netherlands", dial_code: "+31", code: "NL" },
  { name: "New Caledonia", dial_code: "+687", code: "NC" },
  { name: "New Zealand", dial_code: "+64", code: "NZ" },
  { name: "Nicaragua", dial_code: "+505", code: "NI" },
  { name: "Niger", dial_code: "+227", code: "NE" },
  { name: "Nigeria", dial_code: "+234", code: "NG" },
  { name: "North Korea", dial_code: "+850", code: "KP" },
  { name: "Norway", dial_code: "+47", code: "NO" },
  { name: "Oman", dial_code: "+968", code: "OM" },
  { name: "Pakistan", dial_code: "+92", code: "PK" },
  { name: "Palau", dial_code: "+680", code: "PW" },
  { name: "Palestine", dial_code: "+970", code: "PS" },
  { name: "Panama", dial_code: "+507", code: "PA" },
  { name: "Papua New Guinea", dial_code: "+675", code: "PG" },
  { name: "Paraguay", dial_code: "+595", code: "PY" },
  { name: "Peru", dial_code: "+51", code: "PE" },
  { name: "Philippines", dial_code: "+63", code: "PH" },
  { name: "Poland", dial_code: "+48", code: "PL" },
  { name: "Portugal", dial_code: "+351", code: "PT" },
  { name: "Puerto Rico", dial_code: "+1", code: "PR" },
  { name: "Qatar", dial_code: "+974", code: "QA" },
  { name: "Romania", dial_code: "+40", code: "RO" },
  { name: "Russia", dial_code: "+7", code: "RU" },
  { name: "Rwanda", dial_code: "+250", code: "RW" },
  { name: "Réunion", dial_code: "+262", code: "RE" },
  { name: "Saint Kitts and Nevis", dial_code: "+1869", code: "KN" },
  { name: "Saint Lucia", dial_code: "+1758", code: "LC" },
  { name: "Saint Vincent and the Grenadines", dial_code: "+1784", code: "VC" },
  { name: "Samoa", dial_code: "+685", code: "WS" },
  { name: "San Marino", dial_code: "+378", code: "SM" },
  { name: "Saudi Arabia", dial_code: "+966", code: "SA" },
  { name: "Senegal", dial_code: "+221", code: "SN" },
  { name: "Serbia", dial_code: "+381", code: "RS" },
  { name: "Seychelles", dial_code: "+248", code: "SC" },
  { name: "Sierra Leone", dial_code: "+232", code: "SL" },
  { name: "Singapore", dial_code: "+65", code: "SG" },
  { name: "Slovakia", dial_code: "+421", code: "SK" },
  { name: "Slovenia", dial_code: "+386", code: "SI" },
  { name: "Solomon Islands", dial_code: "+677", code: "SB" },
  { name: "Somalia", dial_code: "+252", code: "SO" },
  { name: "South Africa", dial_code: "+27", code: "ZA" },
  { name: "South Korea", dial_code: "+82", code: "KR" },
  { name: "South Sudan", dial_code: "+211", code: "SS" },
  { name: "Spain", dial_code: "+34", code: "ES" },
  { name: "Sri Lanka", dial_code: "+94", code: "LK" },
  { name: "Sudan", dial_code: "+249", code: "SD" },
  { name: "Suriname", dial_code: "+597", code: "SR" },
  { name: "Swaziland", dial_code: "+268", code: "SZ" },
  { name: "Sweden", dial_code: "+46", code: "SE" },
  { name: "Switzerland", dial_code: "+41", code: "CH" },
  { name: "Syria", dial_code: "+963", code: "SY" },
  { name: "São Tomé and Príncipe", dial_code: "+239", code: "ST" },
  { name: "Taiwan", dial_code: "+886", code: "TW" },
  { name: "Tajikistan", dial_code: "+992", code: "TJ" },
  { name: "Tanzania", dial_code: "+255", code: "TZ" },
  { name: "Thailand", dial_code: "+66", code: "TH" },
  { name: "Timor-Leste", dial_code: "+670", code: "TL" },
  { name: "Togo", dial_code: "+228", code: "TG" },
  { name: "Tonga", dial_code: "+676", code: "TO" },
  { name: "Trinidad and Tobago", dial_code: "+1868", code: "TT" },
  { name: "Tunisia", dial_code: "+216", code: "TN" },
  { name: "Turkey", dial_code: "+90", code: "TR" },
  { name: "Turkmenistan", dial_code: "+993", code: "TM" },
  { name: "Tuvalu", dial_code: "+688", code: "TV" },
  { name: "Uganda", dial_code: "+256", code: "UG" },
  { name: "Ukraine", dial_code: "+380", code: "UA" },
  { name: "United Arab Emirates", dial_code: "+971", code: "AE" },
  { name: "United Kingdom", dial_code: "+44", code: "GB" },
  { name: "United States", dial_code: "+1", code: "US" },
  { name: "Uruguay", dial_code: "+598", code: "UY" },
  { name: "Uzbekistan", dial_code: "+998", code: "UZ" },
  { name: "Vanuatu", dial_code: "+678", code: "VU" },
  { name: "Vatican City", dial_code: "+39", code: "VA" },
  { name: "Venezuela", dial_code: "+58", code: "VE" },
  { name: "Vietnam", dial_code: "+84", code: "VN" },
  { name: "Yemen", dial_code: "+967", code: "YE" },
  { name: "Zambia", dial_code: "+260", code: "ZM" },
  { name: "Zimbabwe", dial_code: "+263", code: "ZW" },
];

const nationalitiesFromTibco = [
  "Afghanistan",
  "African",
  "Albanian",
  "Algerian",
  "American",
  "Andorran",
  "Angolana",
  "ANTIGUAN AND BARBUDAN",
  "Argentinean",
  "Armenian",
  "Australian",
  "Austrian",
  "Azerbaijan",
  "Bahamas",
  "Bahraini",
  "Bangladeshi",
  "Barbadian",
  "Barbados",
  "Belarus",
  "Belgian",
  "Belizian",
  "Beninoise",
  "Bermuda",
  "Bhutan",
  "Bolivian",
  "Bosnian",
  "Botswanian",
  "Brazilian",
  "British",
  "Brunei Darussalam",
  "Bulgarian",
  "Burkina Faso",
  "Burma",
  "Burundian",
  "Byzerian",
  "Cambodian",
  "Cameroon",
  "Canadian",
  "Cape Verdean",
  "Chadian",
  "Chile",
  "Chilean",
  "Chinese",
  "Columbian",
  "Comorienne",
  "Congo",
  "Congo, The Democratic Republic of the",
  "Costa Rica",
  "Croatian",
  "Cuban",
  "Cyprus",
  "Czech Republic",
  "Danish",
  "Democratic Republic of the Congo",
  "Deutsch",
  "Djibouti",
  "Dominica",
  "Dominican",
  "Dutch",
  "Ecuador",
  "Egyptian",
  "Equatorial Guinea",
  "Eritrean",
  "Estonia",
  "Estonian",
  "Ethiopian",
  "Fijian",
  "Finland",
  "French",
  "Gabonaise",
  "Gambian",
  "Georgian",
  "German",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greek",
  "Greenland",
  "Grenada",
  "Guatemala",
  "Guineenne",
  "Guyanese",
  "Haitian",
  "Hellenic",
  "HONDURAN",
  "Hungarian",
  "Iceland",
  "Indian",
  "Indonesian",
  "Iranian",
  "Iraqi",
  "Irish",
  "Israeli",
  "Italian",
  "Ivoirienne",
  "Ivorian",
  "Ivorycoast",
  "Jamaican",
  "Japanese",
  "Jordanian",
  "Kazak",
  "KAZAKHSTAN",
  "Kenyan",
  "Kingdom of Lesotho",
  "Korean",
  "Kosovo",
  "Kroatian",
  "Kuwaiti",
  "Kyrgyzstan",
  "Laotian",
  "Latvian",
  "Lebanese",
  "Liberia",
  "Libyan",
  "Liechtenstein",
  "Lithuanian",
  "Luxembourg",
  "Macedonian",
  "Madagascar",
  "Malawi",
  "Malaysian",
  "Maldivian",
  "Mali",
  "Maltese",
  "Mauritania",
  "Mauritius",
  "Mexican",
  "Moldovian",
  "Monacan",
  "Mongolian",
  "Montenegro",
  "Moroccan",
  "Mosotho",
  "Mozambique",
  "Myanmar",
  "Namibian",
  "Nepali",
  "Netherlands",
  "New Guinean",
  "New Zealand",
  "Nicaraguan",
  "Niger",
  "Nigerian",
  "North Korean",
  "Norwegian",
  "Omani",
  "Pakistani",
  "Palestenian",
  "Palestinian Territory, Occupied",
  "Panama",
  "Paraguayan",
  "Peruvian",
  "Philipino",
  "Poland",
  "Portuguese",
  "Puerto Rico",
  "Qatari",
  "Republic Of Burundi",
  "Republic Of Niger",
  "Romanian",
  "Russian",
  "Rwandese",
  "Saint Kitts And Nevis",
  "Saint Lucia",
  "Salvadorean",
  "Saudi",
  "Scotish",
  "Senegal",
  "Serbian",
  "Seychelles",
  "Sierra Leone",
  "Singaporean",
  "Slovak",
  "Slovenian",
  "Solomon Islands",
  "Somalia",
  "South African",
  "South Korean",
  "South Sudanese",
  "Spanish",
  "Sri Lankan",
  "St. Kitts And Nevis",
  "Sudanese",
  "Suriname",
  "SWAZI",
  "Swedish",
  "SWISS",
  "Syrian",
  "Taiwanese",
  "Tajik",
  "Tanzanian",
  "Tchad",
  "Thai",
  "Togolaise",
  "Trinidad and Tobago",
  "Tunisian",
  "Turkey",
  "Turkmenistan",
  "Tuvaluan",
  "UAE",
  "Uganda",
  "Ukranian",
  "Umurundi",
  "Uruguayan",
  "Uzbek",
  "Vanuatuan",
  "Venezuela",
  "Vietnamese",
  "VINCENTIAN",
  "Yemeni",
  "Yoguslavian",
  "Zambian",
  "Zimbabweian",
].sort((a, b) => {
  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
});

export const prefixes = prefixList
  .filter((value) => !!value.dial_code)
  .map((item) => {
    return {
      label: `${item.code} ${item.dial_code}`,
      country: item.code,
      value: item.dial_code,
    };
  });

export const countryCodePrefixes = (currentCountry: string) => {
  const selectedCountry = prefixList.filter((prefix) => prefix.code === currentCountry);
  const otherCountries = prefixList.filter((prefix) => prefix.code !== currentCountry);
  const formatedList = [...selectedCountry, ...otherCountries];
  return formatedList
    .filter((value) => !!value.dial_code)
    .map((item) => {
      return {
        label: `${item.code} ${item.dial_code}`,
        country: item.code,
        value: item.code + "_" + item.dial_code,
      };
    });
};

export const countryNamePrefixes = (currentCountry: string) => {
  const selectedCountry = prefixList.filter((prefix) => prefix.code === currentCountry);
  const otherCountries = prefixList.filter((prefix) => prefix.code !== currentCountry);
  const formatedList = [...selectedCountry, ...otherCountries];
  return formatedList
    .filter((value) => !!value.dial_code)
    .map((item) => {
      return {
        label: `${item.name} ${item.dial_code}`,
        country: item.code,
        value: item.dial_code + "_" + normalizeCountryName(item.name),
      };
    });
};

export const countryCodeLeadPrefixes = (currentCountry: string) => {
  const selectedCountry = prefixList.filter((prefix) => prefix.code === currentCountry);
  const otherCountries = prefixList.filter((prefix) => prefix.code !== currentCountry);
  const formatedList = [...selectedCountry, ...otherCountries];
  return formatedList
    .filter((value) => !!value.dial_code)
    .map((item) => {
      return {
        label: `${item.name} ${item.dial_code}`,
        country: item.code,
        value: item.dial_code + "_" + normalizeCountryName(item.name),
      };
    });
};

export const countriesMapped = prefixList
  .filter((value) => !!value.dial_code)
  .map((item) => {
    return {
      label: item.name,
      value: item.code,
    };
  });

export const nationalitiesMapped = nationalitiesFromTibco.map((item) => {
  return {
    label: item,
    value: item,
  };
});

export const countries = prefixList
  .filter((value) => !!value.code)
  .sort((a, b) => {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  })
  .map((item) => {
    return {
      label: item.name,
      value: item.code,
    };
  });

export const getCountryNameFromCountryCode = (country_code: any) => {
  return prefixList.find((prefix) => prefix.code === country_code)?.name;
};

// Helper function to normalize country names:
// 1. Replace specific characters (like apostrophes and commas) with spaces.
// 2. Remove remaining diacritics and symbols, keeping only letters and spaces.
// 3. Clean up extra spaces.
export const normalizeCountryName = (name: any) => {
  let cleanedName = name;

  // 1. Replace apostrophes (both straight and curly) and commas with spaces
  cleanedName = cleanedName?.replace(/['’,]/g, " ");

  // 2. Normalize to decompose characters (like é into e + ´) and then
  //    remove all characters that are NOT letters (a-z, A-Z) or spaces.
  //    This regex handles removing the decomposed diacritics and any other
  //    special characters or symbols not replaced in step 1.
  cleanedName = cleanedName?.normalize("NFD")?.replace(/[^a-zA-Z\s]/g, "");

  // 3. Trim leading/trailing spaces and replace multiple spaces with a single space
  cleanedName = cleanedName?.trim()?.replace(/\s+/g, " ");

  return cleanedName;
};

export const countryCodeWithTimezonePrefixes = {
  AW: "America/Aruba",
  AF: "Asia/Kabul",
  AO: "Africa/Luanda",
  AI: "America/Anguilla",
  AX: "Europe/Mariehamn",
  AL: "Europe/Tirane",
  AD: "Europe/Andorra",
  AE: "Asia/Dubai",
  AR: "America/Argentina/Buenos_Aires",
  AM: "Asia/Yerevan",
  AS: "Pacific/Pago_Pago",
  AQ: "Antarctica/McMurdo",
  TF: "Indian/Kerguelen",
  AG: "America/Antigua",
  AU: "Australia/Lord_Howe",
  AT: "Europe/Vienna",
  AZ: "Asia/Baku",
  BI: "Africa/Bujumbura",
  BE: "Europe/Brussels",
  BJ: "Africa/Porto-Novo",
  BQ: "America/Kralendijk",
  BF: "Africa/Ouagadougou",
  BD: "Asia/Dhaka",
  BG: "Europe/Sofia",
  BH: "Asia/Bahrain",
  BS: "America/Nassau",
  BA: "Europe/Sarajevo",
  BL: "America/St_Barthelemy",
  BY: "Europe/Minsk",
  BZ: "America/Belize",
  BM: "Atlantic/Bermuda",
  BO: "America/La_Paz",
  BR: "America/Noronha",
  BB: "America/Barbados",
  BN: "Asia/Brunei",
  BT: "Asia/Thimphu",
  BV: "Unknown",
  BW: "Africa/Gaborone",
  CF: "Africa/Bangui",
  CA: "America/St_Johns",
  CC: "Indian/Cocos",
  CH: "Europe/Zurich",
  CL: "America/Santiago",
  CN: "Asia/Shanghai",
  CI: "Africa/Abidjan",
  CM: "Africa/Douala",
  CD: "Africa/Kinshasa",
  CG: "Africa/Brazzaville",
  CK: "Pacific/Rarotonga",
  CO: "America/Bogota",
  KM: "Indian/Comoro",
  CV: "Atlantic/Cape_Verde",
  CR: "America/Costa_Rica",
  CU: "America/Havana",
  CW: "America/Curacao",
  CX: "Indian/Christmas",
  KY: "America/Cayman",
  CY: "Asia/Nicosia",
  CZ: "Europe/Prague",
  DE: "Europe/Berlin",
  DJ: "Africa/Djibouti",
  DM: "America/Dominica",
  DK: "Europe/Copenhagen",
  DO: "America/Santo_Domingo",
  DZ: "Africa/Algiers",
  EC: "America/Guayaquil",
  EG: "Africa/Cairo",
  ER: "Africa/Asmara",
  EH: "Africa/El_Aaiun",
  ES: "Europe/Madrid",
  EE: "Europe/Tallinn",
  ET: "Africa/Addis_Ababa",
  FI: "Europe/Helsinki",
  FJ: "Pacific/Fiji",
  FK: "Atlantic/Stanley",
  FR: "Europe/Paris",
  FO: "Atlantic/Faroe",
  FM: "Pacific/Chuuk",
  GA: "Africa/Libreville",
  GB: "Europe/London",
  GE: "Asia/Tbilisi",
  GG: "Europe/Guernsey",
  GH: "Africa/Accra",
  GI: "Europe/Gibraltar",
  GN: "Africa/Conakry",
  GP: "America/Guadeloupe",
  GM: "Africa/Banjul",
  GW: "Africa/Bissau",
  GQ: "Africa/Malabo",
  GR: "Europe/Athens",
  GD: "America/Grenada",
  GL: "America/Nuuk",
  GT: "America/Guatemala",
  GF: "America/Cayenne",
  GU: "Pacific/Guam",
  GY: "America/Guyana",
  HK: "Asia/Hong_Kong",
  HM: "Unknown",
  HN: "America/Tegucigalpa",
  HR: "Europe/Zagreb",
  HT: "America/Port-au-Prince",
  HU: "Europe/Budapest",
  ID: "Asia/Jakarta",
  IM: "Europe/Isle_of_Man",
  IN: "Asia/Calcutta",
  IO: "Indian/Chagos",
  IE: "Europe/Dublin",
  IR: "Asia/Tehran",
  IQ: "Asia/Baghdad",
  IS: "Atlantic/Reykjavik",
  IL: "Asia/Jerusalem",
  IT: "Europe/Rome",
  JM: "America/Jamaica",
  JE: "Europe/Jersey",
  JO: "Asia/Amman",
  JP: "Asia/Tokyo",
  KZ: "Asia/Almaty",
  KE: "Africa/Nairobi",
  KG: "Asia/Bishkek",
  KH: "Asia/Phnom_Penh",
  KI: "Pacific/Tarawa",
  KN: "America/St_Kitts",
  KR: "Asia/Seoul",
  KW: "Asia/Kuwait",
  LA: "Asia/Vientiane",
  LB: "Asia/Beirut",
  LR: "Africa/Monrovia",
  LY: "Africa/Tripoli",
  LC: "America/St_Lucia",
  LI: "Europe/Vaduz",
  LK: "Asia/Colombo",
  LS: "Africa/Maseru",
  LT: "Europe/Vilnius",
  LU: "Europe/Luxembourg",
  LV: "Europe/Riga",
  MO: "Asia/Macau",
  MF: "America/Marigot",
  MA: "Africa/Casablanca",
  MC: "Europe/Monaco",
  MD: "Europe/Chisinau",
  MG: "Indian/Antananarivo",
  MV: "Indian/Maldives",
  MX: "America/Mexico_City",
  MH: "Pacific/Majuro",
  MK: "Europe/Skopje",
  ML: "Africa/Bamako",
  MT: "Europe/Malta",
  MM: "Asia/Yangon",
  ME: "Europe/Podgorica",
  MN: "Asia/Ulaanbaatar",
  MP: "Pacific/Saipan",
  MZ: "Africa/Maputo",
  MR: "Africa/Nouakchott",
  MS: "America/Montserrat",
  MQ: "America/Martinique",
  MU: "Indian/Mauritius",
  MW: "Africa/Blantyre",
  MY: "Asia/Kuala_Lumpur",
  YT: "Indian/Mayotte",
  NA: "Africa/Windhoek",
  NC: "Pacific/Noumea",
  NE: "Africa/Niamey",
  NF: "Pacific/Norfolk",
  NG: "Africa/Lagos",
  NI: "America/Managua",
  NU: "Pacific/Niue",
  NL: "Europe/Amsterdam",
  NO: "Europe/Oslo",
  NP: "Asia/Kathmandu",
  NR: "Pacific/Nauru",
  NZ: "Pacific/Auckland",
  OM: "Asia/Muscat",
  PK: "Asia/Karachi",
  PA: "America/Panama",
  PN: "Pacific/Pitcairn",
  PE: "America/Lima",
  PH: "Asia/Manila",
  PW: "Pacific/Palau",
  PG: "Pacific/Port_Moresby",
  PL: "Europe/Warsaw",
  PR: "America/Puerto_Rico",
  KP: "Asia/Pyongyang",
  PT: "Europe/Lisbon",
  PY: "America/Asuncion",
  PS: "Asia/Gaza",
  PF: "Pacific/Tahiti",
  QA: "Asia/Qatar",
  RE: "Indian/Reunion",
  RO: "Europe/Bucharest",
  RU: "Europe/Kaliningrad",
  RW: "Africa/Kigali",
  SA: "Asia/Riyadh",
  SD: "Africa/Khartoum",
  SN: "Africa/Dakar",
  SG: "Asia/Singapore",
  GS: "Atlantic/South_Georgia",
  SH: "Atlantic/St_Helena",
  SJ: "Arctic/Longyearbyen",
  SB: "Pacific/Guadalcanal",
  SL: "Africa/Freetown",
  SV: "America/El_Salvador",
  SM: "Europe/San_Marino",
  SO: "Africa/Mogadishu",
  PM: "America/Miquelon",
  RS: "Europe/Belgrade",
  SS: "Africa/Juba",
  ST: "Africa/Sao_Tome",
  SR: "America/Paramaribo",
  SK: "Europe/Bratislava",
  SI: "Europe/Ljubljana",
  SE: "Europe/Stockholm",
  SZ: "Africa/Mbabane",
  SX: "America/Lower_Princes",
  SC: "Indian/Mahe",
  SY: "Asia/Damascus",
  TC: "America/Grand_Turk",
  TD: "Africa/Ndjamena",
  TG: "Africa/Lome",
  TH: "Asia/Bangkok",
  TJ: "Asia/Dushanbe",
  TK: "Pacific/Fakaofo",
  TM: "Asia/Ashgabat",
  TL: "Asia/Dili",
  TO: "Pacific/Tongatapu",
  TT: "America/Port_of_Spain",
  TN: "Africa/Tunis",
  TR: "Europe/Istanbul",
  TV: "Pacific/Funafuti",
  TW: "Asia/Taipei",
  TZ: "Africa/Dar_es_Salaam",
  UG: "Africa/Kampala",
  UA: "Europe/Simferopol",
  UM: "Pacific/Midway",
  UY: "America/Montevideo",
  US: "America/New_York",
  UZ: "Asia/Samarkand",
  VA: "Europe/Vatican",
  VC: "America/St_Vincent",
  VE: "America/Caracas",
  VG: "America/Tortola",
  VI: "America/St_Thomas",
  VN: "Asia/Ho_Chi_Minh",
  VU: "Pacific/Efate",
  WF: "Pacific/Wallis",
  WS: "Pacific/Apia",
  YE: "Asia/Aden",
  ZA: "Africa/Johannesburg",
  ZM: "Africa/Lusaka",
  ZW: "Africa/Harare",
};
